import React, { Component } from 'react';
import {dollarsWithoutCents, imageUrl} from 'helpers/ApplicationHelper';
import I18n from 'lib/i18n/i18n';


class BidsSection extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
          <div id="bids-section" className={this.props.className}>
              <div className="view-and-status hidden">
                  <span className="bids-count">{this.props.item.bids_count} bids</span>
                  <span className="auction-views" >{this.props.item.auction_views} <img src={ imageUrl('item/views.svg') } /></span>
                  <span className="status">{I18n.getString(`itemPage::supportNegotiation::auction_ended::tag`)} <img src={ imageUrl('item/time.svg') } /></span>
              </div>
              <div className={`bid-and-price`}>
                  <span className="title">{I18n.getString(`itemPage::supportNegotiation::${this.props.banner}::bid`)}</span>
                  <span className="value bold">{['lastChance', 'sold', 'shipBack'].includes(this.props.banner) ? dollarsWithoutCents(this.props.item.evaluation_after_buyer_fees) : dollarsWithoutCents(this.props.item.highest_bid_after_buyer_fees)}</span>
              </div>
              <div className="bid-and-price hidden">
                  <span className="title">Minimum price</span>
                  <span className="value">{dollarsWithoutCents(this.props.item.minimum_price)}</span>
              </div>
          </div>

        );
    }
}

export default BidsSection;